import { FC, useRef } from 'react';
import { LoadingAndErrorHandler, PageErrorWithReload, Screen } from '../../components';
import { IressCol, IressForm, IressRow, IressStack } from '@iress-oss/ids-components';
import { ScenarioFormContent } from '../../components/Scenario/ScenarioFormContent';
import { useScenariosHandlers } from '../../hooks';
import { LoadingFields } from '../../components/LoadingFields/LoadingFields';
import { InputType, SkeletonElement } from '@xplan-pension-switching/common';
import { Section } from '../../components/Section/Section';
import '../../styles/Scenarios.css';
import { EditScenarioModal } from '../../components/EditScenarioModal/EditScenarioModal';
import { DeleteScenarioModal } from '../../components/DeleteModal/DeleteScenarioModal';
import { ScenarioModal } from '../../components/Scenario/ScenarioModal/ScenarioModal';

export interface ScenarioValues {
    'scenario-name': string;
    'scenario-owner': string;
    'scenario-case': string;
}

export const ScenarioForm = IressForm<ScenarioValues>;

const loadingPlaceholder = (
    <IressStack gutter="lg">
        <Section heading={'Create a scenario'}>
            <IressRow gutter="lg" verticalAlign="bottom">
                <IressCol span={{ md: 3 }}>
                    <LoadingFields fields={[InputType.Text]} testId="placeholder-scenario-name" />
                </IressCol>
                <IressCol span={{ md: 3 }}>
                    <LoadingFields fields={[InputType.Select]} testId="placeholder-owner" />
                </IressCol>
                <IressCol span={{ md: 3 }}>
                    <LoadingFields fields={[SkeletonElement.Button]} testId="placeholder-create-scenario" />
                </IressCol>
            </IressRow>
        </Section>
        <Section heading={'Existing scenarios'}>
            <LoadingFields fields={[InputType.TextArea]} testId="placeholder-scenario-table" />
        </Section>
    </IressStack>
);

export const Scenarios: FC = () => {
    const modalRef = useRef<HTMLDivElement>(null);
    const { mainFormSubmitHandler, modalSubmitHandler, selectedEntityId } = useScenariosHandlers();

    return (
        <Screen title="Pension switching" data-testid={'scenarios-screen'}>
            <LoadingAndErrorHandler
                LoadingComponentFallback={loadingPlaceholder}
                ErrorComponentFallback={<PageErrorWithReload />}
            >
                <ScenarioForm
                    onSubmit={mainFormSubmitHandler}
                    mode={'onBlur'}
                    data-testid={'scenarios-form'}
                    updateErrorSummaryOnSubmit
                >
                    <ScenarioFormContent />
                </ScenarioForm>
                <div ref={modalRef}>
                    <ScenarioModal
                        onSubmit={modalSubmitHandler}
                        selectedEntityId={selectedEntityId}
                        container={modalRef}
                    />
                    <EditScenarioModal container={modalRef} />
                    <DeleteScenarioModal container={modalRef} />
                </div>
            </LoadingAndErrorHandler>
        </Screen>
    );
};
